<template>
<div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
    <app-sidebar></app-sidebar>
    <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">

            <div class="col-sm-12">
                <vs-breadcrumb align="left" :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      disabled: true
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"></vs-breadcrumb>
                <div class="heading mt-3">
                    <h3 class="text-secondary">Event Form - Event Title</h3>
                    <!-- <img src="../../../assets/bottom_line.png" class="responsive-image" alt="Responsive image" />
        </div> -->
                    <div class="form-group form-row justify-content-end">
                        <a href="#"><span> Start Date: 22-7-2019</span>
                            <span class="ml-4"> End Date: 27-7-2019</span></a>
                    </div>

                    <div class="form-group form-row">
                        <h6 class="sub-frm-title">Event Information</h6>
                        <div class="form-group" style="width:100%;margin:auto 10px">
                            <div class="row">
                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                        </span>
                                        <label class="lbl-label">Event Title</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Training Code</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                            </div>

                            <div class="row">
                                <vs-select class="col-sm-12" label="Type of Training" v-model="select4">
                                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in typeoftrainingArr" />
                                </vs-select>
                            </div>
                            <b-button class="save-btn justify-content-end" @click="showForm()" variant="primary">Save</b-button>
                        </div>
                    </div>

                    <!--Training Form Funding -->
                    <div class="form-group form-row">
                        <h6 class="sub-frm-title">Training Form - Funding Agency</h6>
                        <div class="form-group" style="width:100%;margin:auto 10px">
                            <div class="row">
                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                        </span>
                                        <label class="lbl-label">Funding Organization Name</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Organization Code</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->
                            </div>
                        </div>
                        <div class="form-group form-row mt-3 col-sm-12">
                            <h6 class="sub-frm-title">Contact Person</h6>
                            <div class="form-group" style="width:100%;margin:auto 10px">
                                <div class="row">
                                    <!-- floating input starts -->
                                    <div class="col-sm-4" style="margin-top:10px;">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " />

                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                            </span>
                                            <label class="lbl-label">Name</label>
                                        </div>
                                    </div>
                                    <!-- floating input ends -->

                                    <!-- floating input starts -->
                                    <div class="col-sm-4" style="margin-top:10px;">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " />

                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                <i class="material-icons" style="font-size: 20px;"> email</i>
                                            </span>
                                            <label class="lbl-label">Email</label>
                                        </div>
                                    </div>
                                    <!-- floating input ends -->
                                    <!-- floating input starts -->
                                    <div class="col-sm-4" style="margin-top:10px;">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " />

                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                <i class="material-icons" style="font-size: 20px;">call</i>
                                            </span>
                                            <label class="lbl-label">Contact Number</label>
                                        </div>
                                    </div>
                                    <!-- floating input ends -->
                                </div>
                                <b-button class="save-btn justify-content-end" @click="showForm()" variant="primary">Save</b-button>
                            </div>
                        </div>
                    </div>

                    <!--Training Form Funding -->
                    <div class="form-group form-row">
                        <h6 class="sub-frm-title">Training Form - Project Title</h6>
                        <div class="form-group" style="width:100%;margin:auto 10px">
                            <div class="row">
                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                        </span>
                                        <label class="lbl-label">Project Title</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Project Reference Code</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->
                            </div>
                        </div>
                        <div class="form-group form-row mt-3 col-sm-12">
                            <h6 class="sub-frm-title">Adding Funding Agency</h6>
                            <div class="form-group" style="width:100%;margin:auto 10px">
                                <div class="row">
                                    <!-- floating input starts -->
                                    <div class="col-sm-4" style="margin-top:10px;">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " />

                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                            </span>
                                            <label class="lbl-label">Organization Name</label>
                                        </div>
                                    </div>
                                    <!-- floating input ends -->

                                    <!-- floating input starts -->
                                    <div class="col-sm-4" style="margin-top:10px;">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " />

                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                <i class="material-icons" style="font-size: 20px;"> email</i>
                                            </span>
                                            <label class="lbl-label">Funding Reference Name</label>
                                        </div>
                                    </div>
                                    <!-- floating input ends -->
                                    <!-- floating input starts -->
                                    <div class="col-sm-3" style="margin-top:10px;">
                                        <div class="floating-label">
                                            <input class="floating-input form-control" type="text" placeholder=" " />

                                            <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                <i class="material-icons" style="font-size: 20px;">call</i>
                                            </span>
                                            <label class="lbl-label">Url</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-1 mt-3">
                                        <i class="material-icons" style="font-size: 20px;"> add_circle_outline</i>
                                    </div>
                                    <!-- floating input ends -->
                                </div>
                                <b-button class="save-btn justify-content-end" @click="showForm()" variant="primary">Save</b-button>
                            </div>
                        </div>
                    </div>
                    <!--Training Form Funding -->
                    <div class="form-group form-row">
                        <h6 class="sub-frm-title">Training Form - Program Sub Title</h6>
                        <div class="form-group" style="width:100%;margin:auto 10px">
                            <div class="row">
                                <vs-select class="col-sm-6" label="Project Title" v-model="select4">
                                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in typeoftrainingArr" />
                                </vs-select>
                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:28px">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Program Sub Title</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                                <!-- floating input starts -->
                                <div class="col-sm-11" style="margin-top:10px">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Sub Project Code</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->
                                <div class="col-sm-1 mt-3">
                                    <i class="material-icons" style="font-size: 20px;"> add_circle_outline</i>
                                </div>
                            </div>
                            <b-button class="save-btn justify-content-end" @click="showForm()" variant="primary">Save</b-button>
                        </div>

                    </div>

                    <!--Training Form Funding -->
                    <div class="form-group form-row">
                        <h6 class="sub-frm-title">Training Form - Add Country</h6>
                        <div class="form-group" style="width:100%;margin:auto 10px">
                            <div class="row">
                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                        </span>
                                        <label class="lbl-label">Country Id</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                                <!-- floating input starts -->
                                <div class="col-sm-6" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Add New Country</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->
                                <!-- floating input starts -->
                                <div class="col-sm-4" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                        </span>
                                        <label class="lbl-label">Country Code</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                                <!-- floating input starts -->
                                <div class="col-sm-4" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Add New Province</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->
                                <!-- floating input starts -->
                                <div class="col-sm-4" style="margin-top:10px;">
                                    <div class="floating-label">
                                        <input class="floating-input form-control" type="text" placeholder=" " />

                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                        </span>
                                        <label class="lbl-label">Add City</label>
                                    </div>
                                </div>
                                <!-- floating input ends -->

                            </div>
                            <b-button class="save-btn justify-content-end" @click="showForm()" variant="primary">Save</b-button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
export default {
    data: () => ({
        isSidebar: false,
        popupActivo: false,
        isForm: true,
        isFormData: false,
        selected: "",
        subprogramSelected: "",
        subprogramsettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 3,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        donerSelected: "",
        donersettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
        contact_person: "",
        contact_number: "",
        contact_email: "",
        address: "",
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        textarea: "",
        counterDanger: false,
        mydate: "",

        trainingCheck: false,
        repeatedCheck: false,
        select1Normal: "",
        select1: 1,
        select2: 1,
        select3: 1,
        select4: 1,
        select5: 1,
        select6: 1,
        select7: 1,
        select8: 1,
        trainingtitleArr: [{
                text: "Provincial training for preventiion of drugs",
                value: 1
            },
            {
                text: "Global Training for prevention techniques against drug",
                value: 2
            },
            {
                text: "Global Training 3",
                value: 3
            },
            {
                text: "Global Training 4",
                value: 4
            },
            {
                text: "Global Training 5",
                value: 5
            }
        ],
        pretrainingmanualArr: [{
                text: "PDF",
                value: 1
            },
            {
                text: "Word",
                value: 2
            },
            {
                text: "PPT",
                value: 3
            },
            {
                text: "Video",
                value: 4
            },
            {
                text: "Html",
                value: 5
            }
        ],
        pretrainingpresentationArr: [{
                text: "PDF",
                value: 6
            },
            {
                text: "Word",
                value: 7
            },
            {
                text: "PPT",
                value: 8
            },
            {
                text: "Video",
                value: 9
            },
            {
                text: "Html",
                value: 10
            }
        ],
        pretrainingintroductoryArr: [{
                text: "PDF",
                value: 1
            },
            {
                text: "Word",
                value: 2
            },
            {
                text: "PPT",
                value: 3
            },
            {
                text: "Video",
                value: 4
            },
            {
                text: "Html",
                value: 5
            }
        ],
        pretrainingdetailArr: [{
                text: "PDF",
                value: 1
            },
            {
                text: "Word",
                value: 2
            },
            {
                text: "PPT",
                value: 3
            },
            {
                text: "Video",
                value: 4
            },
            {
                text: "Html",
                value: 5
            }
        ],
        pretrainingtitleArr: [{
                text: "PDF",
                value: 1
            },
            {
                text: "Word",
                value: 2
            },
            {
                text: "PPT",
                value: 3
            },
            {
                text: "Video",
                value: 4
            },
            {
                text: "Html",
                value: 5
            }
        ],
        subprogramArr: [{
                text: "SUB PROGRAM ONE",
                value: 1
            },
            {
                text: "SUB PROGRAM TWO",
                value: 2
            }
        ],
        donernameArr: [{
                text: "UNDP Pakistan",
                value: 1
            },
            {
                text: "UNICEIF",
                value: 2
            },
            {
                text: "UNHCR",
                value: 3
            }
        ],
        typeoftrainingArr: [{
                text: "TRAINING TYPE 1",
                value: 1
            },
            {
                text: "TRAINING TYPE 2",
                value: 2
            },
            {
                text: "TRAINING TYPE 3",
                value: 3
            },
            {
                text: "TRAINING TYPE 4",
                value: 4
            }
        ],
        countryArr: [{
                text: "Pakistan",
                value: 1
            },
            {
                text: "Other",
                value: 2
            }
        ],
        provinceArr: [{
                text: "Khyber Pakhtunkhwa",
                value: 1
            },
            {
                text: "PUNJAB",
                value: 2
            },
            {
                text: "Islamabad",
                value: 3
            },
            {
                text: "Sind",
                value: 4
            },
            {
                text: "Balochistan",
                value: 5
            },
            {
                text: "Azad Kashmir",
                value: 6
            }
        ],
        cityArr: [{
                text: "Mardan",
                value: 1
            },
            {
                text: "Peshawar",
                value: 2
            }
        ],
        departmentArr: [{
                text: "Police Dedpartment KP",
                value: 1
            },
            {
                text: "Police Dedpartment PUNJAB",
                value: 2
            },
            {
                text: "Police Dedpartment ISLAMABAD",
                value: 3
            },
            {
                text: "Sind Police",
                value: 4
            }
        ],
        items: [{
                contact_person: "Dr Saif Ullah",
                department: "Police Dedpartment KP",
                city: "Mardan"
            },
            {
                contact_person: "Dr Ata Ullah",
                department: "Police Dedpartment ISLAMABAD",
                city: "Peshawar"
            }
        ],
        fields: [{
                key: "city",
                label: "City"
            },
            {
                key: "department",
                label: "Department"
            },
            {
                key: "contact_person",
                label: "Contact Person"
            },
            {
                key: "actions",
                label: ""
            }
        ]
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    methods: {
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: 'success',
                title: 'Upload Success',
                text: 'Files have been Uploaded, consectetur'
            })
        }
    }
};
</script>

<style>
#menu-toggle {
    display: none;
}

@media(max-width:768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #f9f9f9;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #f9f9f9;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

/* Uploading file css */
/* .con-img-upload .img-upload{
  height:25px !important;
}
.con-input-upload{
  height:25px !important;
}
h4.text-archive{
  font-size: 13px !important
}
.con-img-upload .img-upload .btn-x-file i{
  font-size:10px !important;
}
.con-img-upload .img-upload .btn-upload-file:not(.on-progress):hover i{

    font-size: 12px !important;
    background: rgba(var(--vs-success),1);
    top: 15% !important;
    padding: 10px;
}

.vs-upload--button-upload:hover {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
    background: rgba(var(--vs-primary),1);
    color: #fff;
} */

.con-img-upload .img-upload {
    width: 150px !important;
}
</style>
